import { Outlet } from 'react-router';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconDownload } from '@sorare/core/src/atoms/icons/system/iconDownload.ts';
import { iconTag } from '@sorare/core/src/atoms/icons/system/iconTag.ts';
import { iconUpload } from '@sorare/core/src/atoms/icons/system/iconUpload.ts';
import {
  MY_SORARE_OFFERS_RECEIVED,
  MY_SORARE_OFFERS_SALES,
  MY_SORARE_OFFERS_SENT,
} from '@sorare/core/src/constants/__generated__/routes';
import { MySorareSubTabsLayout } from '@sorare/marketplace/src/components/mySorare/MySorareSubTabsLayout';
import { TITLES } from '@sorare/marketplace/src/components/mySorare/common/pages';

const tabsValues = [
  {
    to: MY_SORARE_OFFERS_RECEIVED,
    label: TITLES.offers_received,
    icon: (
      <FontAwesomeIcon color="var(--c-onBase-success)" icon={iconDownload} />
    ),
  },
  {
    to: MY_SORARE_OFFERS_SENT,
    label: TITLES.offers_sent,
    icon: <FontAwesomeIcon color="var(--c-red-400)" icon={iconUpload} />,
  },
  {
    to: MY_SORARE_OFFERS_SALES,
    label: TITLES.sales,
    icon: <FontAwesomeIcon color="var(--c-green-400)" icon={iconTag} />,
  },
];

const MySorareOffersLayout = () => {
  return (
    <MySorareSubTabsLayout tabs={tabsValues}>
      <Outlet />
    </MySorareSubTabsLayout>
  );
};
export default MySorareOffersLayout;
